/**
 * Job Client Factory
 *
 * Creates the appropriate JobClient implementation based on config mode.
 */

export { type JobClient } from './job-client.js';
export { DirectJobClient } from './direct-job-client.js';

import type { JobClient } from './job-client.js';
import type { McpServerConfig } from '../types.js';
import { DirectJobClient } from './direct-job-client.js';

export function createJobClient(config: McpServerConfig): JobClient {
  return new DirectJobClient(config);
}
